var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5_64",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5_64",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAA6ElEQVRIDdVTwQ3CMAw8I7ZAiMIQLMEEiAHgwzRIMAITwA4wBEJCZY1gP+zk0TY4QqitYsWKz3buGgND/0gJPM/LFUAHBMz1LNkffL6vNrernHmwI0kQo0AnLtJUXMILEI7iiHmw1iAAU0nusJnGggNrDTT513tvG9RdTAl4abyMAYUtF3izNa06BOw0MFbHs1fr+4XxE7bsKmOQLRsBKQPRtfVWqa5FgwaHrp5BMwYeXXs1aMbAo2v8hXnPXpFH13zZiLAGHl1jet6zBnloGeKvDWTQWq+ZDhqDvsZGBo5B8wwlX2bg6wPbHlSl3UbAvAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLayoutIcon);
export default __webpack_public_path__ + "static/media/dashboard_layout_icon.d2de632a45e52411d8263e9efd23ffb3.svg";
export { ForwardRef as ReactComponent };